<script setup>
import { Link } from '@inertiajs/vue3';

defineProps({
  lookup: Object
});
</script>
<template>
  <table class="w-full table-fixed">
    <thead class="bg-dark">
      <tr>
        <th class="pb-3 text-left md:w-2/12">
          {{ $t('lookup.partials.dns.card_detail_mx.rdtype') }}
        </th>
        <th class="pb-3 text-left md:w-1/12">TTL</th>
        <th class="pb-3 text-left md:w-2/12">
          {{ $t('lookup.partials.dns.card_detail_mx.priority') }}
        </th>
        <th class="pb-3 text-left">
          {{ $t('lookup.partials.dns.card_detail_mx.addresses') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(mailserver, i) in lookup.mailservers" :key="i">
        <td>MX</td>
        <td>{{ lookup.ttl }}</td>
        <td>{{ mailserver.preference }}</td>
        <td>
          <Link
            :href="route('lookup.show', ['dns', mailserver.exchange])"
            class="text-primary-600"
          >
            {{ mailserver.exchange }}
          </Link>
        </td>
      </tr>
    </tbody>
  </table>
</template>
